import { DeepPartial, DeepReadonly } from 'ts-essentials';
import { IElementModelProps } from '@src/slide/domain/ui-model/element-modeles/Interface/model-props/element-model-props.interface';
import { ICTHyperlinkDmlA, STHyperlinkColor, DeltaOf } from '@tencent/slide-sdk-model';
import { transMailObj2Str, transMailStr2Obj } from '@src/slide/domain/ui-model/element-modeles/property/link/ui-sdk-transform';
import { ITextRunStyle } from '@src/slide/domain/ui-model/element-modeles/property/text/interface/editor-styles.interface';
import _set from 'lodash/set';
import _unset from 'lodash/unset';

export enum ILinkAttr {
    link = 'link', // 形状|图片
    href = 'href' // textRun
}

/**
 * 链接
 */
export class LinkConverter {
    /**
     * 链接的ui -> sdk 映射
     * @param sdkData
     * @param uiData
     * @param attr 形状|图片是link  textRun是href
     */
    // eslint-disable-next-line complexity
    public static convertPartialDataFromSdkToUi(
        sdkData: DeepReadonly<DeepPartial<ICTHyperlinkDmlA>>,
        uiData: IElementModelProps | ITextRunStyle,
        attr = ILinkAttr.link,
    ): void {
        if (sdkData.action === 'ppaction://media') {
            // 音视频的忽略
            delete uiData[attr];
            return;
        }
        const hrefData: any = {};
        if (sdkData.id) {
            if (sdkData.id.indexOf('mailto') >= 0) {
                hrefData.mail = transMailStr2Obj(sdkData.id);
            } else {
                hrefData.url = sdkData.id;
            }
        }
        if (sdkData.tooltip) {
            hrefData.tooltip = sdkData.tooltip;
        }
        if (sdkData.action) {
            hrefData.slideJump = {
                action: sdkData.action,
                target: sdkData.id,
            };
            delete hrefData.url;
            delete hrefData.mail;
        }
        if (Object.keys(hrefData).length) {
            if (attr === ILinkAttr.link) {
                uiData[attr] = { href: hrefData };
            } else {
                uiData[attr] = hrefData;
            }
        } else {
            delete uiData[attr];
        }
        // 链接图文混排
        if (sdkData.iconMode) {
            hrefData.iconMode = sdkData.iconMode;
        }
        if (sdkData.mimeType) {
            hrefData.mimeType = sdkData.mimeType;
        }
        // 链接是否为用户自定义颜色
        if (sdkData.extLst?.ext?.[0]?.hlinkClr?.[0]?.val) {
            hrefData.colorType = STHyperlinkColor[sdkData.extLst.ext[0].hlinkClr[0].val];
        } else {
            delete hrefData.colorType;
        }
    }

    /**
     * 链接的sdk -> ui 映射
     * @param uiData
     * @param sdkData
     * @param attr 形状|图片是link  textRun是href
     */
    public static convertPartialDataFromUiToSdk(
        uiData: DeepReadonly<DeepPartial<IElementModelProps>> | DeepReadonly<DeepPartial<ITextRunStyle>>,
        sdkData: DeltaOf<ICTHyperlinkDmlA>,
        attr = ILinkAttr.link,
    ): void {
        const hrefData = (attr === ILinkAttr.link) ? uiData?.[attr]?.href : uiData?.[attr];
        if (!hrefData) {
            return;
        }
        // id
        sdkData.id = hrefData.mail ? transMailObj2Str(hrefData.mail) : hrefData.url;
        // tooltip
        if (hrefData.tooltip) {
            sdkData.tooltip = hrefData.tooltip;
        }
        // action
        if (hrefData.slideJump?.action) {
            sdkData.action = hrefData.slideJump.action;
        } else {
            sdkData.action = null;
        }
        // target
        if (hrefData.slideJump?.target) {
            sdkData.id = hrefData.slideJump.target;
        }
        // 链接颜色跟随文字
        if (hrefData.colorType) {
            _set(sdkData, 'extLst.ext[0].hlinkClr[0].val', STHyperlinkColor[hrefData.colorType]);
        } else {
            _unset(sdkData, 'extLst.ext[0].hlinkClr');
        }
        // 链接图文混排
        if (typeof hrefData.iconMode === 'boolean') {
            sdkData.iconMode = hrefData.iconMode;
        }
        if (hrefData.mimeType) {
            sdkData.mimeType = hrefData.mimeType;
        }
    }
}
